// src/pages/Account/DangerZone.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const DangerZone = ({ onDelete }) => {
    const { t } = useTranslation();
    return (
        <div>
            <h2 className="text-xl font-semibold text-red-500 mb-4">{t('account.dangerZone.title')}</h2>
            <p className="text-slate-400 mb-4">{t('account.dangerZone.description')}</p>
            <button onClick={onDelete} className="btn-danger hover:bg-brand-orange p-2">{t('account.dangerZone.deleteButton')}</button>
        </div>
    );
};

export default DangerZone;